import styled from 'styled-components';
import sizes from 'utils/screenSizes';

export const Container = styled.div`
  padding: 10px;
  background: var(--color-popeyes-orange);
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  z-index: 5;
  position: relative;
  img {
    height: 81px;
    width: auto;
  }

  @media all and (min-width: ${sizes.notebook}) {
    height: 50%;
  }
  @media all and (min-width: ${sizes.desktop}) {
    img {
      height: 120px;
      width: auto;
    }
  }
  @media all and (max-width: ${sizes.notebook}) {
    display: none;
  }
`;

export const SocialMedial = styled.div`
  width: 30%;
  justify-content: center;
  display: flex;
  a {
    margin: 0 4%;
  }
  img {
    height: 100%;
    width: 100%;
    max-width: 32px;
  }
  @media only all and (min-width: 1500px) {
    img {
      max-width: 40px;
    }
  }
`;

export const Links = styled.div`
  width: 60%;
  display: flex;
  justify-content: space-around;
  a {
    font-family: 'ChickenSansRegular';
    color: var(--color-salt-white);

    font-weight: 700;
    font-size: 1rem;
  }
  @media only all and (min-width: 1500px) {
    a {
      font-size: 1.3rem;
    }
  }
  @media only all and (min-width: 1500px) {
    a {
      font-size: 1.7rem;
    }
  }
`;

export const LegalInfo = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  a {
    font-family: 'ChickenSansRegular';
    color: var(--color-salt-white);

    font-weight: 400;
    font-size: 1rem;
    margin: 0 3%;
  }
  @media only all and (min-width: 1500px) {
    a {
      font-size: 1.3rem;
    }
  }
  @media only all and (min-width: 1500px) {
    a {
      font-size: 1.7rem;
    }
  }
`;
